import { NgModule, LOCALE_ID } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ExtraOptions, PreloadAllModules, RouterModule } from '@angular/router';
import { MarkdownModule } from 'ngx-markdown';
import { FuseModule } from '@fuse';
import { FuseConfigModule } from '@fuse/services/config';
import { CoreModule } from 'app/core/core.module';
import { appConfig } from 'app/core/config/app.config';
import { LayoutModule } from 'app/layout/layout.module';
import { AppComponent } from 'app/app.component';
import { appRoutes } from 'app/app.routing';
import {ExampleComponent} from './modules/example/example.component';
import { UsersComponent } from './modules/users/users.component';
import {MatIconModule} from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import {MatMenuModule} from '@angular/material/menu';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatSortModule} from '@angular/material/sort';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import {MatSelectModule} from '@angular/material/select';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import {MatPaginatorModule} from '@angular/material/paginator';
import {MatInputModule} from '@angular/material/input';
import {MatTooltipModule} from '@angular/material/tooltip';
import {MatRippleModule} from '@angular/material/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DossierInterventionComponent } from './modules/dossier-intervention/dossier-intervention.component';
import { FormDossierInterventionComponent } from './modules/dossier-intervention/form-dossier-intervention/form-dossier-intervention.component';
import { MatTabsModule } from '@angular/material/tabs';
import { FicheInterventionComponent } from './modules/dossier-intervention/fiche-intervention/fiche-intervention.component';
import { FormFicheInterventionComponent } from './modules/dossier-intervention/fiche-intervention/edit-fiche-intervention/form-fiche-intervention/form-fiche-intervention.component';
import { MatDialogModule } from '@angular/material/dialog';
import { EquipementComponent } from './modules/equipement/equipement.component';
import { ModalFormTypeEquipementComponent } from './modules/equipement/modal-form-type-equipement/modal-form-type-equipement.component';
import { CalendrierComponent } from './modules/calendrier/calendrier.component';
import { CalendarModule, CalendarUtils, DateAdapter  } from 'angular-calendar';
import { adapterFactory } from 'angular-calendar/date-adapters/date-fns';
import localeFr from '@angular/common/locales/fr';
import { registerLocaleData } from '@angular/common';
import { CalendarHeaderComponent } from './modules/calendrier/calendar-header.component';
import { ToastrModule } from 'ngx-toastr';
import { EditFicheInterventionComponent } from './modules/dossier-intervention/fiche-intervention/edit-fiche-intervention/edit-fiche-intervention.component';
import { UppercaseFirstLetterPipe } from './shared/uppercaseFirstLetter.pipe';
import { EquipementPipe } from './modules/equipement/equipement.pipe';
import { PermissionComponent } from './modules/permission/permission.component';
import { PhotoDossierInterventionComponent } from './modules/dossier-intervention/photo-dossier-intervention/photo-dossier-intervention.component';
import { FormulaireAutorisationInterventionComponent } from './modules/dossier-intervention/fiche-intervention/edit-fiche-intervention/formulaire-autorisation-intervention/formulaire-autorisation-intervention.component';
import { ModalFormDebrisTypeEquipementComponent } from './modules/dossier-intervention/fiche-intervention/edit-fiche-intervention/form-fiche-intervention/modal-form-debris-type-equipement/modal-form-debris-type-equipement.component';
import { CroquisComponent } from './modules/croquis/croquis.component';
import { HeureTravailleeComponent } from './modules/dossier-intervention/heure-travaillee/heure-travaillee.component';
import { DossierEquipementComponent } from './modules/dossier-intervention/dossier-equipement/dossier-equipement.component';
import {DossierInterventionIdComponent} from './modules/dossier-intervention/id/dossier-intervention-id.component';
import {
    ModalDossierEquipement
} from './modules/dossier-intervention/dossier-equipement/modal-dossier-equipement/modal-dossier-equipement.component';
import {ModalConfirm} from './shared/modal-confirm/modal-confirm.component';
import {DossierCroquisComponent} from './modules/dossier-intervention/dossier-croquis/dossier-croquis.component';
import {
    ModalDossierCroquis
} from './modules/dossier-intervention/dossier-croquis/modal-dossier-croquis/modal-dossier-croquis.component';
import {
    DossierRapportPsychometriqueComponent
} from './modules/dossier-intervention/dossier-rapport-psychometrique/dossier-rapport-psychometrique.component';
import {DossierInterventionV2Component} from './modules/dossier-intervention/v2-dossier/dossier-intervention-v2.component';
import {CardComponent} from './components/card/card.component';
import {PieceV2Component} from './modules/dossier-intervention/v2-dossier/piece/piece-v2.component';
import {EtageV2Component} from './modules/dossier-intervention/v2-dossier/etage/etage-v2.component';
import {EquipementV2Component} from './modules/dossier-intervention/v2-dossier/equipement/equipement-v2.component';
import {ModalEquipementV2Component} from './modules/dossier-intervention/v2-dossier/equipement/modal-equipement-v2.component';
import {
    FicheInterventionV2Component
} from './modules/dossier-intervention/v2-dossier/intervention/fiche-intervention-v2.component';
import {DossierV2Component} from './modules/dossier-intervention/v2-dossier/dossier/dossier-v2.component';
import {CommunicationComponent} from './modules/dossier-intervention/v2-dossier/communication/communication.component';
import {
    CommunicationInputComponent
} from './modules/dossier-intervention/v2-dossier/communication/communication-input.component';
import {
    CommunicationCommentComponent
} from './modules/dossier-intervention/v2-dossier/communication/communication-comment.component';
import {AvatarComponent} from './components/avatar.component';

import {ModalActiviteAssechementComponent} from './modules/dossier-intervention/dossier-rapport-psychometrique/modal-activite-assechement.component';
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import {
    FicheInterventionWorkOrdersComponent
} from './modules/dossier-intervention/fiche-intervention/work-order/fiche-intervention-work-orders.component';
import {ModalPhotoComponent} from './modules/dossier-intervention/fiche-intervention/photo/modal-photo.component';
import {
    ModalWorkOrderComponent
} from './modules/dossier-intervention/fiche-intervention/work-order/modal-work-order.component';
import {
    ModalActiviteEauComponent
} from './modules/dossier-intervention/dossier-rapport-psychometrique/modal-activite-eau.component';
import {ModalPieceComponent} from './modules/dossier-intervention/v2-dossier/piece/modal-piece.component';
//Import automatique

const routerConfig: ExtraOptions = {
    preloadingStrategy       : PreloadAllModules,
    scrollPositionRestoration: 'enabled'
};

registerLocaleData(localeFr);

@NgModule({
    declarations: [
        AppComponent,
        ExampleComponent,
        UsersComponent,
        DossierInterventionComponent,
        DossierInterventionIdComponent,
        FormDossierInterventionComponent,
        FicheInterventionComponent,
        FormFicheInterventionComponent,
		EquipementComponent,
        ModalFormTypeEquipementComponent,
        CalendrierComponent,
        CalendarHeaderComponent,
        EditFicheInterventionComponent,
        UppercaseFirstLetterPipe,
        EquipementPipe,
        PermissionComponent,
        PhotoDossierInterventionComponent,
        FormulaireAutorisationInterventionComponent,
        ModalFormDebrisTypeEquipementComponent,
        CroquisComponent,
        HeureTravailleeComponent,
        DossierEquipementComponent,
        DossierCroquisComponent,
        DossierRapportPsychometriqueComponent,
        DossierInterventionV2Component,
        ModalDossierCroquis,
        ModalDossierEquipement,
        ModalConfirm,
        PieceV2Component,
        EtageV2Component,
        EquipementV2Component,
        DossierV2Component,
        CommunicationComponent,
        CommunicationInputComponent,
        CommunicationCommentComponent,
        FicheInterventionV2Component,
        ModalEquipementV2Component,
        ModalActiviteAssechementComponent,
        //Components
        CardComponent,
        AvatarComponent,
        FicheInterventionWorkOrdersComponent,
        ModalPhotoComponent,
        ModalWorkOrderComponent,
        ModalActiviteEauComponent,
        ModalPieceComponent,
		//Déclaration automatique
    ],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        RouterModule.forRoot(appRoutes, routerConfig),
        FuseModule,
        FuseConfigModule.forRoot(appConfig),
        CoreModule,
        LayoutModule,
        MarkdownModule.forRoot({}),
        MatButtonModule,
        MatCheckboxModule,
        MatFormFieldModule,
        MatIconModule,
        MatInputModule,
        MatMenuModule,
        MatPaginatorModule,
        MatProgressBarModule,
        MatRippleModule,
        MatSortModule,
        MatSelectModule,
        MatSlideToggleModule,
        MatTooltipModule,
        ReactiveFormsModule,
        MatTabsModule,
        MatDialogModule,
        ToastrModule.forRoot({
            timeOut: 3500,
            positionClass: 'toast-bottom-right',
            preventDuplicates: true,
        }), // ToastrModule added
        CalendarModule.forRoot({
            provide: DateAdapter,
            useFactory: adapterFactory,
        }),
        FormsModule,
        MatAutocompleteModule
    ],
    providers: [
        { provide: CalendarUtils, useClass: CalendarUtils },
        { provide: LOCALE_ID, useValue: 'fr' },
        { provide: Window, useValue: window }
    ],
    bootstrap   : [
        AppComponent
    ]
})
export class AppModule
{
}
